//@flow
import api from '../Utils/apiBuilder';
import Constants from '../constants';
import Dispatcher   from '../dispatcher';

export default {
  getQuotes() {
    return api('carts')
      .optionalAuth()
      .get()
      .dispatch(Constants.GET_QUOTES_SUCCESS);
  },

  getQuote(quoteId:string) {
    return api('carts', quoteId)
      .optionalAuth()
      .get()
      .dispatch(Constants.GET_QUOTE_SUCCESS);
  },

  createQuote(quoteData:Object = {}) {
    return api('carts')
      .optionalAuth()
      .post(quoteData)
      .dispatch(Constants.CREATE_QUOTE_SUCCESS);
  },

  setPromoCode(quoteId:string, code:string) {
    return api('carts', quoteId)
      .optionalAuth()
      .put({ coupon_code: code })
      .dispatch(Constants.SET_PROMO_CODE_SUCCESS);
  },

  updateQuote(quoteId:string, quoteData:Object) {
    return api('carts', quoteId)
      .optionalAuth()
      .put(quoteData)
      .dispatch(Constants.UPDATE_QUOTE_SUCCESS)
      .onSuccess((newData) => {
        if (quoteData.reserve_items) Dispatcher.dispatchAction(Constants.RESERVE_QUOTE_SUCCESS, newData);
        return newData;
      });
  },

  deleteQuote(quoteId:string) {
    return api('carts', quoteId)
      .del()
      .dispatch(Constants.DELETE_QUOTE_SUCCESS);
  },

  deleteSsQuotes() {
    return api('carts', 'deleteSsQuotes')
      .del()
      .dispatch(Constants.DELETE_SS_QUOTES_SUCCESS);
  },

  addItem(quoteId:string, sku:string, qty:number = 1, params:Object = {}) {
    const items = [{ sku, qty, params }];
    return this.updateQuote(quoteId, { items }).dispatch(Constants.ADD_QUOTE_ITEM_SUCCESS);
  },

  addItems(quoteId:string, items:{sku:string, qty:number|string}[]) {
    return this.updateQuote(quoteId, { items });
  },

  addItemsByReorderToken(quoteId:string, token:string) {
    return this.updateQuote(quoteId, { reorder_token: token });
  },

  updateItemQty(quoteId:string, id:string, qty:number) {
    const items = [{ id, qty }];
    return this.updateQuote(quoteId, { items }).dispatch(Constants.UPDATE_QUOTE_ITEM_QTY_SUCCESS);
  },

  deleteItems(quoteId:string, itemIds:string[]) {
    const items = itemIds.map(id => {
      return { id, qty: 0 };
    });
    return this.updateQuote(quoteId, { items }).dispatch(Constants.DELETE_QUOTE_ITEM_SUCCESS);
  },
};
